export default "__VITE_ASSET__DNjEkG6U__"